import { render, staticRenderFns } from "./OfferBox.vue?vue&type=template&id=6ae0c44d&scoped=true&"
import script from "./OfferBox.vue?vue&type=script&lang=js&"
export * from "./OfferBox.vue?vue&type=script&lang=js&"
import style0 from "./OfferBox.vue?vue&type=style&index=0&id=6ae0c44d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae0c44d",
  null
  
)

export default component.exports